export const biErrorCodes = {
  configurationError: 'CONFIGURATION_ERROR',
  actionHandlerError: 'ACTION_HANDLER_ERROR',
  eventHandlerError: 'EVENT_HANDLER_ERROR',
  ReporterError: 'REPORTER_ERROR'
}